module.exports = __webpack_public_path__ + "img/thumbnail_AmericanFlamingo_m_normal.c604c75e.png";